import { useQueryParam } from '@/ui'
import { PLATFORMS, WINDOWS } from './format'

/** The selected window lives in the URL rather than component state, so it
 *  survives the hop from the list into an app's page. `fallback` is only what
 *  an absent param means on THIS page; an explicit `?days=` always wins, which
 *  is what makes the hop carry the choice across. Choosing the fallback
 *  removes the param. */
export function useWindowDays(fallback: number): [number, (d: number) => void] {
  const [raw, set] = useQueryParam('days', String(fallback))
  const n = Number(raw)
  return [WINDOWS.includes(n) ? n : fallback, (d) => set(String(d))]
}

/** The platform filter, kept in the URL for the same reason: a filter that
 *  resets when you open an app is a filter you cannot trust, and the numbers
 *  on the app's page have to be scoped the way the list was. */
export function usePlatform(): [string, (p: string) => void] {
  const [raw, set] = useQueryParam('platform')
  return [PLATFORMS.includes(raw) ? raw : '', set]
}
